if (window.__mainProductJsInitialized) {
	/* Already loaded once from theme.liquid — skip re-init */
} else {
window.__mainProductJsInitialized = true;

;(function () {
	const initProductAccordion = () => {
		if (typeof window.jQuery === 'undefined') return;

		const aboutToggleItems = window.jQuery('.about__accordion-toggle')

		aboutToggleItems.each(function () {
			const $ = window.jQuery;
			const currentToggle = $(this)
			const siblingToggles = currentToggle.siblings(
				'.about__accordion-description'
			)

			currentToggle.click(function () {
				if (!currentToggle.hasClass('active')) {
					aboutToggleItems.each(function () {
						const siblingToggle = $(this)
						siblingToggle.removeClass('active')
						siblingToggle
							.siblings('.about__accordion-description')
							.stop()
							.slideUp(300)
					})

					currentToggle.addClass('active')

					siblingToggles.stop().slideDown(300)
				} else {
					currentToggle.removeClass('active')
					siblingToggles.stop().slideUp(300)
				}
			})
		})
	}

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			'.product-media-modal__content'
		)
		const images = imagesWrapper?.querySelectorAll('.js-image-zoom') || []

		images.forEach((el) => {
			el.addEventListener('click', (e) => {
				imagesWrapper.classList.toggle('zoom')
			})
		})
	}

	const formatFreeShippingAmount = (value) => {
		const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
		const formatString = theme.moneyFormat

		return formatString.replace(placeholderRegex, value)
	}

	const setTotalFreeShipping = () => {
		if (document.querySelector('.js-free-shipping')) {
			const freeShippingTotal = document.querySelector('.free-shipping-total')
			if (freeShippingTotal) {
				const minSpend = Number(freeShippingTotal.dataset.minSpend)
				if (minSpend && minSpend > 0) {
					freeShippingTotal.innerText = `${formatFreeShippingAmount(
						Math.round(minSpend * (Shopify.currency.rate || 1))
					)}`
				}
			}
		}
	}
	function changeIconsViewBox() {
		const textWithIcon = document.querySelectorAll('.text_with_icon')
		textWithIcon.forEach((item) => {
			const icons = item.querySelectorAll('.icon-pack')
			icons.forEach((icon) => {
				icon.setAttribute('viewBox', '0 0 20 20')
			})
		})
	}

	//document.addEventListener('scroll', () => {
	//	const navigation = document.querySelector('.product__media_navigation')
	//	if (navigation) {
	//		const footer = document.querySelector('.footer')
	//		const navigationHeight = navigation.offsetHeight
	//		const screen = window.scrollY
	//		const overview = document.querySelector('#overview').scrollTop
	//		const overviewBottom =
	//			document.querySelector('#overview').clientHeight + overview
	//		if (screen >= overview && screen <= overviewBottom) {
	//			document.querySelector('#overview-link').classList.add('active')
	//		} else {
	//			document.querySelector('#overview-link').classList.remove('active')
	//		}
	//		if (window.innerHeight + screen - navigationHeight > footer.offsetTop) {
	//			navigation.style.opacity = '0'
	//			navigation.style.visibility = 'hidden'
	//		} else {
	//			navigation.style.opacity = '1'
	//			navigation.style.visibility = 'visible'
	//		}
	//	}
	//})

	const navigationSections = [
		{
			sectionSelector: '#overview',
			linkSelector: '#overview-link',
		},
		{
			sectionSelector: '#product-specifications',
			linkSelector: '#specifications-link',
		},
	]

	function navigationInit(sections) {
		const navigation = document.querySelector('.product__media_navigation')
		if (navigation) {
			navigation.style.transform = 'translateX(-50%) translateY(calc(100% + 16px))'
		}
		document.addEventListener('scroll', () => {
			if (navigation) {
				navigation.classList.add('show-navigation')
			}
			if (navigation) {
				const footer = document.querySelector('.footer')
				const navigationHeight = navigation.offsetHeight
				const secondSection = document.querySelectorAll('#MainContent .shopify-section')[1]
				const screen = window.scrollY
				sections.forEach((section, i) => {
					if (section) {
						const em = document.querySelector(`${section.sectionSelector}`)
						if (em) {
							const rect = em.getBoundingClientRect()	
							if (rect.top <= 1 && rect.top > rect.height * -1) {
								document
									.querySelector(`${section.linkSelector}`)
									.classList.add('active')
							} else {
								document
									.querySelector(`${section.linkSelector}`)
									.classList.remove('active')
							}
							document.querySelector(`${section.linkSelector}`).addEventListener('click', () => {
								em.scrollIntoView({ behavior: 'smooth' });
							})
						} else {
							document.querySelector(`${section.linkSelector}`).style.display = 'none';
						}
					}
				})
				
				const rect = secondSection.getBoundingClientRect();
				const isSecondSectionScrolled = rect.top < 0;
				const isNearFooter = window.innerHeight + screen - navigationHeight > footer.offsetTop;

				navigation.style.transform = isSecondSectionScrolled && !isNearFooter
				? 'translateX(-50%) translateY(0)'
				: 'translateX(-50%) translateY(calc(100% + 16px))';
			}
		})
	}

	const INVENTORY_TABLE_SCROLL_OFFSET = 100

	const initScrollToInventoryTable = () => {
		document.addEventListener('click', (event) => {
			const button = event.target.closest('button[data-btn-scroll-down-to-inventory-table]')
			if (!button) return

			const table = document.querySelector('b2b-plus-product-table')
			if (!table) return

			const top = window.scrollY + table.getBoundingClientRect().top - INVENTORY_TABLE_SCROLL_OFFSET
			window.scrollTo({ top, behavior: 'smooth' })
		})
	}

	document.addEventListener('shopify:section:load', function () {
		initProductAccordion()
		initZoomImage()
		setTotalFreeShipping()
		changeIconsViewBox()
		navigationInit(navigationSections)
	})

	navigationInit(navigationSections)
	initProductAccordion()
	initZoomImage()
	setTotalFreeShipping()
	changeIconsViewBox()
	initScrollToInventoryTable()
})()


function checkForKSChartContainer() {
	let count = 0;
	const interval = setInterval(() => {
	  const ksChartContainer = document.querySelector('.ks-chart-container');
	  if (ksChartContainer) {
		document.querySelector('.size-chart').classList.add('active');
		clearInterval(interval);
	  }
	  count++;
	  if (count >= 20) {
		// console.log('ks-chart-container not found after 10 seconds.');
		clearInterval(interval);
	  }
	}, 500);
  }
  
  document.addEventListener('DOMContentLoaded', checkForKSChartContainer);


document.addEventListener('DOMContentLoaded', function () {
	checkProductMediaVideo();
	sezzleCheck();

	if( document.querySelector('square-placement') ){
		document.querySelector('square-placement').closest('.shopify-app-block').classList.add('hidden');
		document.querySelector('.payment-installment-wrapper').append(document.querySelector('square-placement'));		
	}	
});

function sezzleCheck(){	
	const sezzelParent = document.querySelector('.shopify-app-block div[id*=sezzle-widget]') ? 
		document.querySelector('.shopify-app-block div[id*=sezzle-widget]').closest('.shopify-app-block'): null;
	sezzelParent?.classList.add('hidden');
	if( document.querySelector('.shopify-app-block div[id*=sezzle-widget]') && 
			document.querySelector('.shopify-app-block div[id*=sezzle-widget]').closest('.shopify-app-block').children.length > 4 ){		
		sezzelParent.querySelectorAll('.sezzle-shopify-info-button').forEach(function(sezzelEle){
			document.querySelector('.payment-installment-wrapper').append(sezzelEle);
		});
		sezzelParent.classList.add('hidden');
	}else{
		if( sezzelParent ){
			//const sezzelParent = document.querySelector('.shopify-app-block div[id*=sezzle-widget]').closest('.shopify-app-block');
			sezzelParent.getAttribute('data-sezzle-count') == null && (
				sezzelParent.setAttribute('data-sezzle-count', 0)	
			);
			let count = Number(sezzelParent.getAttribute('data-sezzle-count')) + 1;
			if( count < 11 ){
				setTimeout(()=>{				
					sezzelParent.setAttribute('data-sezzle-count', count)	
					sezzleCheck();
				}, 1000);			
			}
		}
	}
}




/* Play video on scroll */
function checkProductMediaVideo(){	
  const mediaItems = document.querySelectorAll('.product__media-list .product__media-item');

  if (!mediaItems.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const mediaItem = entry.target;
      const hasDeferredMedia = mediaItem.querySelector('deferred-media');
			const isVisible = entry.isIntersecting;

      if (!hasDeferredMedia) return;

			// console.log('entry.isIntersecting', entry.isIntersecting);

      if (isVisible) {
				if (!hasDeferredMedia.getAttribute('loaded')) {
					// window.pauseAllMedia();
					mediaItem.classList.add('show');
					hasDeferredMedia.loadContent();        
				}
				if( hasDeferredMedia.querySelector('video') ){
					hasDeferredMedia.querySelector('video').play().catch(() => {})
				}
      } else {				
				if( hasDeferredMedia.querySelector('video') ){
					hasDeferredMedia.querySelector('video').pause();
				}else{
					window.pauseAllMedia();
				}
        mediaItem.classList.remove('show');
      }
    });
  }, {
    root: null,           // 👈 Use the viewport (window scroll)
    threshold: 0.5        // Adjust as needed (50% visibility)
  });

  mediaItems.forEach(item => {
    observer.observe(item);
  });

}
/* Play video on scroll */


document.querySelectorAll('.shopify-section.pro-card-list').forEach((ele) =>{
    if( ele.querySelector('.product-card-list') == null ){
      ele.classList.add('no-image-gird')
    }
})

// Handle window resize event for responsive adjustments
window.addEventListener('resize', function () {
  // If screen size is greater than 1199px, destroy Swiper on .js-media-list if applied
  if (window.innerWidth > 1199) {
    document.querySelectorAll('.js-media-list').forEach((elem) => {
      if (elem.swiper && typeof elem.swiper.destroy === 'function') {
        elem.swiper.destroy(true, true);
        // Optionally remove swiper classes if needed
        elem.classList.remove('swiper-initialized', 'swiper-container-initialized', 'swiper-container-horizontal');
      }
    });
  }else{
	if(document.querySelectorAll('.js-media-list.swiper-initialized').length == 0){
		sliderInit(true);
	}
  }
});

const section_svg = `<svg class="section-svg small-hide" xmlns="http://www.w3.org/2000/svg" width="170" height="500" viewBox="0 0 170 500" fill="none">
    <path d="M-178.999 95.8085C-152.857 83.1285 -122.436 77.0184 -91.5304 73.0154C-66.5058 69.7779 -42.2901 77.8615 -18.6909 86.799C0.695368 94.1473 18.4346 104.808 35.9002 115.908C48.883 124.157 58.0912 135.972 66.2053 148.707C83.4372 177.669 90.4396 209.241 91.1798 241.768C92.0451 279.543 86.4252 316.031 70.5656 350.492C52.7138 389.274 23.2143 412.859 -18.9387 420.549C-73.1615 430.446 -124.202 418.997 -172.89 391.367C-218.045 365.74 -241.976 326.49 -252.076 277.759C-260.47 237.275 -258.042 197.897 -241.927 160.555C-228.229 128.815 -205.877 108.844 -178.999 95.8085Z" fill="#D5DED4"/>
    <path d="M70.7626 211.208C101.171 227.13 115.042 251.613 120.3 284.88C121.43 292.021 125.17 325.075 112.912 324.342C104.735 323.849 110.128 311.14 110.245 307.375C111.411 270.298 98.538 240.934 65.8538 223.024C32.974 205.005 -11.6634 210.228 -37.3171 239.979C-49.9692 254.648 -57.9753 279.74 -61.2544 298.658C-62.3027 304.699 -61.4472 322.194 -66.0625 324.529C-76.8612 329.988 -74.063 311.876 -73.6297 306.569C-72.2264 289.367 -66.3029 266.511 -58.2856 251.286C-33.9682 205.103 24.8812 187.187 70.7626 211.208Z" fill="white"/><path d="M54.7026 245.205C70.6337 252.875 82.9671 266.513 90.9062 282.158C94.2383 288.725 105.823 321.08 95.9631 324.856C85.62 328.82 86.727 309.675 84.8792 302.853C79.4673 282.872 69.6469 268.209 51.6192 258.445C14.6916 238.439 -14.6464 268.38 -25.3977 302.697C-27.2902 308.746 -26.4096 325.83 -35.5507 323.579C-42.528 321.863 -39.9674 309.81 -38.7179 304.239C-29.3923 262.709 11.0715 224.196 54.7026 245.205Z" fill="white"/><path d="M42.5313 267.933C52.3935 272.681 60.0279 281.123 64.9394 290.806C67.0025 294.873 74.1755 314.9 68.0731 317.237C61.6688 319.692 62.3536 307.84 61.2103 303.616C57.8614 291.248 51.7813 282.173 40.6248 276.129C17.7638 263.745 -0.395339 282.279 -7.05126 303.52C-8.22254 307.266 -7.67743 317.839 -13.3354 316.448C-17.6543 315.384 -16.0693 307.924 -15.295 304.475C-9.52521 278.769 15.5218 254.928 42.5313 267.933Z" fill="white"/>
    </svg>`;

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.shopify-section:not(:first-child) [data-rebuy-shopify-product-ids]').forEach(function(ele, index){
		ele.classList.add('container')
		ele.closest('.shopify-section').classList.add('rebuy-section');
		ele.closest('.shopify-section').classList.add('hidden');
		if( index == 0 ){
			ele.closest('.shopify-app-block').insertAdjacentHTML('beforeend', section_svg);
			ele.closest('.shopify-app-block').classList.add('related-products');
		}
	})

	const accordionItems = document.querySelectorAll('.product-tab .accordion-item:not([data-accordion-bound])');
	document.querySelectorAll('.product-tab .accordion-content-inner').forEach(function(element){
		//element.closest('.accordion-content').style.setProperty('--max-height', `${element.offsetHeight}px`);
	});

	accordionItems.forEach(item => {
		const header = item.querySelector('.product-tab .accordion-header');
		if (!header) return;
		item.setAttribute('data-accordion-bound', '');

		header.addEventListener('click', () => {
			const element = header.closest('.accordion-item').querySelector('.accordion-content-inner');
			element && (
				header.closest('.accordion-item').querySelector('.accordion-content').style.setProperty('--max-height', `${element.offsetHeight}px`)
			);
			// Toggle the active class on the clicked item
			item.classList.toggle('active');

			document.querySelectorAll('.product-tab .accordion-item').forEach(otherItem => {
				if (otherItem !== item) {
					otherItem.classList.remove('active');
				}
			});
			setTimeout(()=>{
				const header_top = header.getBoundingClientRect().top;
				if( header_top < 0){
					header.scrollIntoView({ behavior: 'smooth', block: 'start', inline: "start" })
				}
			}, 300);
		});

		// Add keyboard accessibility
		header.setAttribute('tabindex', '0');
		header.setAttribute('role', 'button');
		header.setAttribute('aria-expanded', 'false');

		header.addEventListener('keydown', (e) => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				header.click();
			}
		});
	});

	/* Product thumbnail  */
	productThumbnailHeight()
	/* Product thumbnail  */

	document.addEventListener('rebuy.ready', function(event){
		// console.log('rebuy.ready event', event.detail.widget);
		const widget = event.detail.widget;

		const ele = widget.template;

		if( ele.closest('#rebuy-cart') == null ){
			if( ele.closest('.main-product') == null ){
				ele.closest('.shopify-section').classList.remove('hidden');
				if( widget.data.products.length == 0 ){
					ele.closest('.shopify-block').classList.add('hidden');
				}

				ele.querySelectorAll('.rebuy-product-block:not(.swatched--added)').forEach(function(ele_block){
					ele_block.querySelectorAll('.rebuy-color-swatches input').forEach((ele_input)=>{
						const handle = handleize(ele_input.value);
						if( handle != '' ){
							let url = `url('https://stonz.com/cdn/shop/files/${handle}.png')`;
							ele_input.closest('.rebuy-color-swatch').style.setProperty("--swatch-color", handle);
							ele_input.closest('.rebuy-color-swatch').style.setProperty("--swatch-image", url);
							ele_block.classList.add('swatched--added');
						}
					});
				});
			}else{
				const ele_pro_block = ele.querySelector('.rebuy-button')?.closest('.rebuy-product-block');
				if( ele_pro_block != undefined ){
					ele.querySelector('.rebuy-button').insertAdjacentHTML('beforeend', plus_svg);
					ele.querySelector('.rebuy-button').addEventListener('click', function(){
						setTimeout(()=>{
							const inputs = ele_pro_block.querySelectorAll('.rebuy-color-swatches input').length ? ele_pro_block.querySelectorAll('.rebuy-color-swatches input') : ele_pro_block.querySelectorAll('.rebuy-color-swatch input');
							inputs.forEach((ele_input) => {
								const handle = handleize(ele_input.value);
								if( handle != '' ){
									let url = `url('https://stonz.com/cdn/shop/files/${handle}.png')`;
									ele_input.closest('.rebuy-color-swatch').style.setProperty("--swatch-color", handle);
									ele_input.closest('.rebuy-color-swatch').style.setProperty("--swatch-image", url);
								// ele_pro_block.classList.add('swatched--added');
								}
							});
						},50)
					});

					setTimeout(function(){
						const app_block_ele = ele.closest('.shopify-app-block');
						const inputs = app_block_ele.querySelectorAll('.rebuy-color-swatches input').length? app_block_ele.querySelectorAll('.rebuy-color-swatches input') : app_block_ele.querySelectorAll('.rebuy-color-swatch input');
						inputs.forEach((ele_input) => {
							const handle = handleize(ele_input.value);
							if( handle != '' ){
								let url = `url('https://stonz.com/cdn/shop/files/${handle}.png')`;
								ele_input.closest('.rebuy-color-swatch').style.setProperty("--swatch-color", handle);
								ele_input.closest('.rebuy-color-swatch').style.setProperty("--swatch-image", url);
								//ele_pro_block.classList.add('swatched--added');
							}
						});
					}, 1000);
				}
			}
		}

	});

	// document.addEventListener('rebuy.change', function(event){
	//   console.log('rebuy.change event', event.detail);
	// });

	const container = document.querySelector('.product__media-list .swiper-wrapper');
	if (container) {
		container.addEventListener('scroll', function() {
			const reachedBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 50;
			if (reachedBottom) {
				document.querySelector('.product__main .button.btn-show-more')?.classList.add('hide-btn');
			} else {
				document.querySelector('.product__main .button.btn-show-more.hide-btn') && (
					document.querySelector('.product__main .button.btn-show-more').classList.remove('hide-btn')
				);
			}
		});
	}

});

window.addEventListener('load', () => {
	productThumbnailHeight(null);
});

function productThumbnailHeight(ele = null){
	const doc_selector = ele != null ? ele : document;

	if( doc_selector.querySelectorAll('.swiper-wrapper .product__media-item:not(.hidden)').length >= 6 && window.innerWidth > 1199 ){
		let div_height=0;
		doc_selector.querySelectorAll('.swiper-wrapper .product__media-item:not(.hidden)').forEach(function(ele, index){
			if( index == 0 || index == 2 || index == 4 ){
				div_height += ele.clientHeight
				if ( index == 2 ){
					div_height += 40
				}
			}else{
				// if( index > 5 ){
				//   ele.classList.add('hidden');
				// }
			}
		});
		const mediaList = doc_selector.querySelector('.product__media-list .swiper-wrapper') || doc_selector.querySelector('.product__media-list');
		// if( window.innerWidth > 1199 &&  div_height > 0 && div_height > window.innerHeight ){
		// 	if (mediaList) mediaList.style.height = `${div_height}px`;
		// }
		if(doc_selector.querySelectorAll('.swiper-wrapper .product__media-item:not(.hidden)').length > 6){
			doc_selector.querySelector('.btn-show-more')?.classList.remove('hidden');
		}else{
			doc_selector.querySelector('.btn-show-more')?.classList.add('hidden');
		}
	}else{
		const mediaList = doc_selector.querySelector('.product__media-list .swiper-wrapper') || doc_selector.querySelector('.product__media-list');
		if (mediaList) mediaList.style.height = '';
		doc_selector.querySelector('.btn-show-more')?.classList.add('hidden');
	}
}

function handleize(str) {
	return str
		.toLowerCase()
		.trim()
		.replace(/['"]/g, '')                // remove quotes
		.replace(/[^a-z0-9]+/g, '-')         // replace non-alphanumerics with dashes
		.replace(/^-+|-+$/g, '');            // remove leading/trailing dashes
}

function switchTableColum(event, element){
	event.preventDefault();
	element.closest('.unit-switcher').querySelector('button.active').classList.remove('active');
	element.classList.add('active');
	const ele_table = element.closest('.size-table-section').querySelector('table');
	let hide_index = null, show_index = null;
	const selected = element.dataset.type.trim();
	const not_selected = element.closest('.unit-switcher').querySelector('button:not([data-type="'+ selected +'"])').dataset.type.trim()

	ele_table.querySelectorAll('th').forEach(function(ele_th, index){
		const text = ele_th.innerText.trim();
		if( text.indexOf(selected) > -1 ){
			ele_th.style.display = 'table-cell';
			show_index = index;
		}
		if( text.indexOf(not_selected) > -1 ){
			ele_th.style.display = 'none';
			hide_index = index;
		}
	});

	ele_table.querySelectorAll('tr').forEach(function(ele_tr){
		ele_tr.querySelectorAll('td:nth-child('+ (hide_index+1) +')').forEach(function(ele_td){
			ele_td.style.display = 'none';
		});
		ele_tr.querySelectorAll('td:nth-child('+ (show_index+1) +')').forEach(function(ele_td){
			ele_td.style.display = 'table-cell';
		});
	});

}

function showMoreImages(ele) {

	const productMain = ele.closest('.product__main');
	const mediaItems = productMain.querySelectorAll('.product__media-item');
	const btn = ele;

	const container = document.querySelector('.product__media-list .swiper-wrapper');
	if (!container) return;

	for (let i = 0; i < mediaItems.length; i++) {
		const item = mediaItems[i];
		const itemTop = item.offsetTop;
		const itemBottom = itemTop + item.offsetHeight;
		const containerTop = container.scrollTop;
		const containerBottom = containerTop + container.clientHeight;

		if (itemTop >= containerBottom) {
				// Scroll to bring this item fully into view
				container.scrollTo({
						top: itemTop,
						behavior: 'smooth'
				});
				return;
		} else if( containerBottom >= itemTop ){
				container.scrollTo({
						top: containerBottom,
						behavior: 'smooth'
				});
				return;
		}
	}
	return;

	// Show next 6 hidden media items
	let shown = 0;
	for (let i = 0; i < mediaItems.length; i++) {
		const item = mediaItems[i];
		if (item.classList.contains('hidden')) {
			item.classList.remove('hidden');
			shown++;
			if (shown === 6) break;
		}
	}

	// If no more hidden items, hide the button
	//const anyHidden = Array.from(mediaItems).some(item => item.classList.contains('hidden'));
	const anyHidden = productMain.querySelectorAll('.product__media-item.hidden').length > 0
	if (!anyHidden) {
		btn.classList.add('hidden');
	}
}

// Keep helpers available to onclick handlers + global.js even if block-scoped
window.productThumbnailHeight = productThumbnailHeight;
window.handleize = handleize;
window.switchTableColum = switchTableColum;
window.showMoreImages = showMoreImages;
}

